export const formatarTelefone = (value) => {
    if (!value) return ""; // Retorna string vazia se for null ou undefined

    value = value.replace(/\D/g, ""); // Remove tudo que não for número
    value = value.slice(0, 11); // Limita a 11 dígitos

    if (value.length >= 11) {
      return value.replace(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    } else if (value.length >= 7) {
      return value.replace(/^(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3");
    } else if (value.length >= 3) {
      return value.replace(/^(\d{2})(\d{0,5})/, "($1) $2");
    } else {
      return value; // Retorna o que tem até o momento
    }
  };
